import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useHead } from '@unhead/vue'

import { mapLocaleToHrefLang } from '@/i18n/helpers'
import { useI18nAddon } from '@/i18n/i18n'

import { isPWARuntime } from './components_new/PWAInstall/utils'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const { currentLocale } = useI18nAddon()

useHead({
    htmlAttrs: {
        class: 'strict-px',
        lang: mapLocaleToHrefLang(currentLocale.value),
        translate: isPWARuntime() ? 'no' : 'yes',
    },
    meta: isPWARuntime()
        ? [
              {
                  name: 'viewport',
                  content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no',
              },
          ]
        : [],
})

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createBlock(_component_RouterView))
}
}

})